import { PayloadAction, createSlice } from '@reduxjs/toolkit';


type ItemType = {
  id: number,
  name: string,
};

type TenantUserListSliceState = {
  items: Array<ItemType>,
  loading: boolean,
};
const initialState: TenantUserListSliceState = {
  items: [],
  loading: true,
};

export const tenantUserListSlice = createSlice({
  name: 'tenantUserList',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<Array<ItemType>>) => {
      state.items = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItems,
  setLoading,
} = tenantUserListSlice.actions;

export default tenantUserListSlice.reducer;